import { Button, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CreateNewStudyArea() {
  const { t } = useTranslation();

  function navigateToBasePath() {
    window.open(`/`);
  }

  return (
    <StyledButton variant="green-outlined" onClick={navigateToBasePath}>
      {t("label.newProjectArea")}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  margin-right: ${({ theme }) => theme.spacing(1)};
`;
